import { mapperModuleNavigationLink, mapperModuleMediaCard } from '../../../core/data-layer/modules/mappers'
import mapperNews from '../../../core/data-layer/news/mapper-news'
import { mapperFinancials } from '../../../core/data-layer/mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page press and media mapper
 * normalizes data to be used in pages

 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  const headerPrimaryLink = data?.headerPrimaryLink
    ? { ...mapperModuleNavigationLink(data.headerPrimaryLink, options.getUrl), type: 'button' }
    : null
  const headerSecondaryLink = data?.headerSecondaryLink
    ? {
        ...mapperModuleNavigationLink(data.headerSecondaryLink, options.getUrl),
        iconRight: { category: 'arrows', name: 'chevron-right-small' }
      }
    : null

  const officeCitiesData = data?.offices
    ?.map((item: any) => ({ ...item.city, image: item.image }))
    .filter((city: any, cityIndex: number, cities: any[]) => cities.findIndex((i) => i.id === city.id) === cityIndex)

  const locations = officeCitiesData?.length
    ? [
        officeCitiesData.slice(0, Math.ceil(officeCitiesData.length / 2)),
        officeCitiesData.slice(Math.ceil(officeCitiesData.length / 2), officeCitiesData.length)
      ]
    : []

  const categories = {
    commercial: data.newsCategories.categoryCommercial || '',
    investor_relations: data.newsCategories.categoryInvestorRelations || ''
  }

  const imageOptionsPressItems = {
    sizes: {
      small: { width: 327, height: 184, aspectRatio: '16/9' },
      medium: { width: 312, height: 176, aspectRatio: '16/9' },
      large: { width: 368, height: 207, aspectRatio: '16/9' }
    },
    resize: true,
    lazy: true
  }

  // Get the current financial year by getting the year from the last half or full year item
  const financialsFullYearData = data.financials?.fullYearData?.items || []
  const financialsHalfYearData = data.financials?.halfYearData?.items || []
  const financialYear = Math.max(
    ...financialsFullYearData.map((i) => i.year).concat(financialsHalfYearData.map((i) => i.year))
  )
  return {
    headerLinks: [headerPrimaryLink, headerSecondaryLink].filter(Boolean),
    newsroomLink: mapperModuleNavigationLink(data.newsroomLink, options.getUrl),
    financialsEyebrow: data.financialsEyebrow || '',
    financialsTitle: data.financialsTitle || '',
    financialYear: financialYear || 0,
    financialItems: mapperFinancials({
      fullYear: data.financials?.fullYearData,
      halfYear: data.financials?.halfYearData
    }),
    locationsTitle: data.locationsTitle || '',
    externalPressTitle: data.externalPressTitle || '',
    externalPressItems:
      data.externalPressItemsCollection?.items?.map((item) =>
        mapperModuleMediaCard(item, { ...options, imageOptions: imageOptionsPressItems })
      ) || null,
    news: mapperNews(data?.news, options, categories) || [],
    locations
  }
}
